<template>
  <p
    class="mt-0 pt-5 mb-0 pb-0 text-caption font-weight-bold text--primary"
  >
    {{ title }}
  </p>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'SectionHeader',
  props: {
    title: { type: String, required: false, default: '' },
  },
  data() {
    return {};
  },
});
</script>
